import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { TVODEntitlement } from '../../../entity/interface/iEntitlements';

export interface IGetTvodUseCase {
    execute(apiKey: string, username: string, token: string): Promise<TVODEntitlement[]>;
}

export class GetTvodUseCase implements IGetTvodUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getTvodRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, username: string, token: string): Promise<TVODEntitlement[]> {
        const response = await this.getTvodRepository.getTVods(apiKey, username, token);
        return response.data.entitledTvods || [];
    }
}
